export default __webpack_public_path__ + "static/benefits-bg-bed47b0425badbb6f3a1e4a62025db82.jpg";